import { useEffect} from "react";
import "./reportes.css";
import { enumReporteSeleccionado } from "../../componentes/FuncionesLocales.js";
import { useStoreHome } from "../Home/useStoreHome.js";
import EntradaReportes from "../../componentes/EntradaReportes/EntradaReportes.jsx";
import SalidaReportes from "../../componentes/SalidaReportes/SalidaReportes.jsx";
import ExportarReporte from "../../componentes/ExportarReporte/ExportarReporte.jsx";
import { formatearFechaExportacion } from "../../servicios/reportesExportacion.js";
import { useStoreReportes } from "./useStoreReportes.js";
import TipoProductoFiltro from "../../componentes/TipoProductoFiltro/TipoProductoFiltro.jsx";

const Reportes = () => {
  const FechaDesde = useStoreReportes((state) => state.FechaDesde);
  const FechaHasta = useStoreReportes((state) => state.FechaHasta);
  const Lote = useStoreReportes((state) => state.LoteProduccion);
  const TipoProducto = useStoreReportes((state) => state.TipoProducto);
  
  useEffect(() => {
    useStoreHome.setState({ ReportesSeleccionado: enumReporteSeleccionado.PRODUCCION });
  }, []);



  return (
    <div className="reportes">
      <h2 className="titulo-p">Producción</h2>
      <div className="reportes-exportacion">
        <TipoProductoFiltro />
        <ExportarReporte endpoint="PISeunReportes/ListaEntradasSalidas" nombre="Entradas y salidas" filters={{ FechaDesde: formatearFechaExportacion(FechaDesde), FechaHasta: formatearFechaExportacion(FechaHasta), Lote: Lote || "", TipoProducto }} />
      </div>

      <div className="rep-content-scroll">
        <EntradaReportes />
        <SalidaReportes />
      </div>


    </div>
  );
};

export default Reportes;
